import React, { Fragment } from "react";
import {
  Card,
  Colors,
  InputGroup,
  Tooltip,
  Button,
  Classes,
  Popover,
  Position,
  AnchorButton
} from "@blueprintjs/core";
import styled from "styled-components";
import { injectIntl, FormattedMessage } from "react-intl";
import QRCode from "qrcode";
import { withCopyState } from "app/proposals/ProposalView";
import {
  Twitter as TwitterButton,
  Facebook as FacebookButton
} from "react-social-sharing";

const TopicTitle = styled.h5`
  text-align: center;
  padding-bottom: 30px;
`;

const Icon = styled.img`
  height: 4em;
  display: block;
  margin: 0 auto;
`;

const TopicDescription = styled.p`
  padding-top: 30px;
`;

const ShareUrlStyle = styled.div`
  & .copy-url-input {
    margin: 12px 0;
  }
  & h5 {
    font-size: 16px;
    margin: 0 0 12px 0;
  }
  & img {
    border: 2px solid ${Colors.GRAY5};
    border-radius: 16px;
    display: block;
  }
`;

const SocialButtonWrapper = styled.div`
  display: inline-block;
  & > a {
    margin: 0.1rem;
  }
  margin-top: 15px;
`;

const ShareUrl = withCopyState(props => {
  const { done, copyUrl, url, intl } = props;
  let qrSrc = "data:image/svg+xml;base64,";
  QRCode.toString(props.url, { scale: 7 }, (error, qrString) => {
    if (error) throw error;
    qrSrc = `${qrSrc}${window.btoa(qrString)}`;
  });
  return (
    <ShareUrlStyle>
      <h5>
        <FormattedMessage id="topic.url" defaultMessage="Topic URL" />
      </h5>
      {done && (
        <p style={{ color: Colors.GREEN3 }}>
          <Icon iconName="small-tick" />
          <FormattedMessage
            id="clipboard.copied.text"
            defaultMessage="Copied to clipboard"
          />{" "}
        </p>
      )}
      <div className="copy-url-input">
        <InputGroup
          type="text"
          defaultValue={url}
          id="copyUrlInput"
          rightElement={
            <Tooltip
              content={intl.formatMessage({
                id: "tooltip.clipboard.copy",
                defaultMessage: "Copy to clipboard"
              })}
            >
              <Button
                className={Classes.MINIMAL}
                iconName="clipboard"
                onClick={copyUrl}
              />
            </Tooltip>
          }
        />
      </div>
      <h5>
        <FormattedMessage id="proposal.share.qrcode" defaultMessage="QRCode" />
      </h5>
      <img
        alt={intl.formatMessage({
          id: "proposal.share.qrcode",
          defaultMessage: "QRCode"
        })}
        src={qrSrc}
      />
    </ShareUrlStyle>
  );
});

const ShareButton = props => {
  const { shareURL, intl, ...rest } = props;
  return (
    <Popover
      popoverClassName="pt-popover-content-sizing"
      position={Position.BOTTOM}
    >
      <AnchorButton {...rest} />
      <ShareUrl path={shareURL} intl={intl} />
    </Popover>
  );
};

const ShareButtonWithMargin = styled(ShareButton)`
  margin-top: 15px;
  margin-right: 15px;
`;

const StyledTwitterButton = styled(TwitterButton)`
  margin-right: 15px;
`;

const TopicDetail = props => {
  const {
    topic: { description, title, icon, pathName },
    intl
  } = props;
  const descriptionLength = 140;
  const isLongText = description.length > descriptionLength;
  const shareURL = `/topics/${pathName}`;
  return (
    <Fragment>
      <Card>
        <TopicTitle>{title}</TopicTitle>
        <Icon src={icon} />
        {isLongText ? (
          <TopicDescription
            style={{ textAlign: "justify" }}
            dangerouslySetInnerHTML={{ __html: description }}
          />
        ) : (
          <TopicDescription
            style={{ textAlign: "center" }}
            dangerouslySetInnerHTML={{ __html: description }}
          />
        )}
      </Card>
      <ShareButtonWithMargin
        iconName="share"
        text={intl.formatMessage({
          id: "proposal.share",
          defaultMessage: "Share..."
        })}
        shareURL={shareURL}
        intl={intl}
      />
      <SocialButtonWrapper>
        <StyledTwitterButton message={title} link={window.location.href} />
      </SocialButtonWrapper>
      <SocialButtonWrapper>
        <FacebookButton medium message={title} link={window.location.href} />
      </SocialButtonWrapper>
    </Fragment>
  );
};

export default injectIntl(TopicDetail);



// WEBPACK FOOTER //
// ./src/app/topics/TopicDetail.js